import { Link } from 'react-router-dom';
import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

const steps = [
  {
    number: '01',
    icon: 'ri-seedling-line',
    title: 'Explore Grátis',
    subtitle: 'Sem compromisso',
    description: 'Comece com 12 exercícios de PNL 100% gratuitos. Sem cadastro, sem cartão — só você e sua transformação.',
    cta: { label: 'Exercícios gratuitos', href: '/exercicios-gratis' },
    dark: false,
  },
  {
    number: '02',
    icon: 'ri-compass-3-line',
    title: 'Descubra seus Padrões',
    subtitle: 'Autoconhecimento profundo',
    description: 'Identifique as crenças limitantes, bloqueios emocionais e comportamentos que impedem seus resultados.',
    cta: { label: 'Fazer o Quiz', href: '/quiz' },
    dark: false,
  },
  {
    number: '03',
    icon: 'ri-brain-line',
    title: 'Aprofunde o Protocolo',
    subtitle: 'Técnicas completas',
    description: 'Desbloqueie os protocolos completos com áudios guiados, workbooks e práticas avançadas de reprogramação.',
    cta: { label: 'Ver planos', href: '/planos' },
    dark: false,
  },
  {
    number: '04',
    icon: 'ri-trophy-line',
    title: 'Transforme sua Vida',
    subtitle: 'Resultados mensuráveis',
    description: 'Entre para a comunidade de líderes, acompanhe suas conquistas e celebre vitórias reais a cada semana.',
    cta: { label: 'Comunidade', href: '/comunidade' },
    premium: true,
  },
];

export default function JornadaMetodo() {
  return (
    <section className="py-28 bg-[#0a0a0a] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/25 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/10 to-transparent"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(201,164,64,0.04),transparent_60%)]"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <ScrollRevealWrapper animation="fade-up">
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-4 mb-6">
              <div className="h-px w-10 bg-gradient-to-r from-transparent to-gold-500/60"></div>
              <span className="text-gold-400 text-xs font-semibold tracking-[0.35em] uppercase font-['Montserrat']">
                Sua Jornada de Transformação
              </span>
              <div className="h-px w-10 bg-gradient-to-l from-transparent to-gold-500/60"></div>
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold text-white mb-5 leading-tight">
              Como Funciona<br />
              <span className="text-gold-400">o Método</span>
            </h2>
            <p className="text-white/50 text-lg max-w-2xl mx-auto leading-relaxed font-light font-['Montserrat']">
              Uma jornada estruturada — do primeiro exercício gratuito até a transformação completa.
              Cada etapa foi desenhada para construir sobre a anterior.
            </p>
          </div>
        </ScrollRevealWrapper>

        {/* Steps grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mb-14 relative">
          {/* Linha conectora desktop */}
          <div className="hidden lg:block absolute top-12 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-gold-500/30 via-gold-500/50 to-gold-500/30 z-0 pointer-events-none"></div>

          {steps.map((step, i) => (
            <ScrollRevealWrapper key={i} animation="fade-up" delay={0.08 * i}>
              <div
                className={`relative rounded-2xl overflow-hidden flex flex-col group transition-all duration-300 hover:-translate-y-1 ${
                  step.premium
                    ? 'bg-gradient-to-br from-gold-500 to-gold-700'
                    : 'bg-[#111111] border border-gold-500/10 hover:border-gold-500/30'
                }`}
              >
                <div className="p-7 flex flex-col flex-1">
                  {/* Número + ícone */}
                  <div className="flex items-center justify-between mb-6 relative z-10">
                    <span className={`font-display text-5xl font-bold leading-none ${step.premium ? 'text-[#0a0a0a]/15' : 'text-gold-500/15'}`}>
                      {step.number}
                    </span>
                    <div className={`w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${step.premium ? 'bg-white/20' : 'bg-gold-500/10 border border-gold-500/20'}`}>
                      <i className={`${step.icon} text-lg ${step.premium ? 'text-[#0a0a0a]' : 'text-gold-400'}`}></i>
                    </div>
                  </div>

                  <div className="flex-1 relative z-10">
                    <div className={`text-xs font-semibold tracking-widest uppercase mb-2 font-['Montserrat'] ${step.premium ? 'text-[#0a0a0a]/60' : 'text-gold-400/60'}`}>
                      {step.subtitle}
                    </div>
                    <h3 className={`font-display text-lg font-bold mb-3 leading-snug ${step.premium ? 'text-[#0a0a0a]' : 'text-white'}`}>
                      {step.title}
                    </h3>
                    <p className={`text-sm leading-relaxed font-light mb-6 font-['Montserrat'] ${step.premium ? 'text-[#0a0a0a]/70' : 'text-white/45'}`}>
                      {step.description}
                    </p>
                  </div>

                  <Link
                    to={step.cta.href}
                    className={`inline-flex items-center gap-2 text-sm font-semibold transition-all whitespace-nowrap font-['Montserrat'] ${
                      step.premium
                        ? 'text-[#0a0a0a] bg-white/90 hover:bg-white px-4 py-2 rounded-full'
                        : 'text-gold-400 hover:text-gold-300'
                    }`}
                  >
                    {step.cta.label}
                    <i className="ri-arrow-right-line text-xs"></i>
                  </Link>
                </div>
              </div>
            </ScrollRevealWrapper>
          ))}
        </div>

        {/* Barra de prova social */}
        <ScrollRevealWrapper animation="fade-up" delay={0.4}>
          <div className="bg-[#111111] border border-gold-500/10 rounded-2xl p-7 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-5">
              <div className="flex -space-x-3">
                {[
                  'https://public.readdy.ai/ai/img_res/dea53382ed8f9b444e4b62cce6adda5d.jpg',
                  'https://readdy.ai/api/search-image?query=professional%20executive%20woman%20smiling%20portrait%20dark%20background%20elegant%20gold&width=40&height=40&seq=jm-soc2&orientation=squarish',
                  'https://readdy.ai/api/search-image?query=professional%20woman%20confident%20portrait%20dark%20minimal%20background&width=40&height=40&seq=jm-soc3&orientation=squarish',
                  'https://readdy.ai/api/search-image?query=executive%20woman%20smiling%20confident%20portrait%20dark%20background%20premium&width=40&height=40&seq=jm-soc4&orientation=squarish',
                ].map((src, i) => (
                  <img key={i} src={src} alt="Membro" className="w-10 h-10 rounded-full border-2 border-[#111111] object-cover" />
                ))}
              </div>
              <div>
                <div className="font-semibold text-white text-sm font-['Montserrat']">+10.000 pessoas já percorreram essa jornada</div>
                <div className="flex items-center gap-1 mt-0.5">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-gold-400 text-xs"></i>
                  ))}
                  <span className="text-xs text-white/35 ml-1 font-['Montserrat']">4.9 de satisfação</span>
                </div>
              </div>
            </div>
            <Link
              to="/exercicios-gratis"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] rounded-full font-bold text-sm tracking-wide hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap font-['Montserrat']"
            >
              <i className="ri-play-circle-line text-lg"></i>
              Começar pela Etapa 1 — Grátis
            </Link>
          </div>
        </ScrollRevealWrapper>
      </div>
    </section>
  );
}
